import { Box, Group, Skeleton, Stack } from "@mantine/core";
import classes from "../../NotificationBell.module.css";

export function NotificationListSkeleton() {
  return (
    <Stack gap={0}>
      {Array.from({ length: 4 }).map((_, i) => (
        <Box key={i} className={classes.skeletonItem}>
          <Group gap={8} wrap="nowrap" align="flex-start">
            <Skeleton circle height={28} width={28} style={{ flexShrink: 0 }} />
            <Box style={{ flex: 1 }}>
              <Skeleton height={11} width="55%" mb={5} />
              <Skeleton height={10} width="80%" mb={4} />
              <Skeleton height={9} width="30%" />
            </Box>
          </Group>
        </Box>
      ))}
    </Stack>
  );
}
